var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayiconsvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 1.884c-6.43 0-11.617 5.124-11.617 11.415 0 6.29 5.187 11.415 11.616 11.415 6.43 0 11.616-5.124 11.616-11.415 0-6.291-5.187-11.415-11.616-11.415zM.114 13.299C.115 6.005 6.121.116 13.5.116S26.883 6.005 26.883 13.3s-6.006 13.183-13.384 13.183S.115 20.591.115 13.299z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M11.178 8.617l7.407 4.92-7.407 4.92v-9.84z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M11.178 8.617l7.407 4.92-7.407 4.92v-9.84z",
    strokeWidth: 1.768,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "arrow"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayiconsvg);
export default __webpack_public_path__ + "static/media/playiconsvg.e6bf723fdd30cbc8ae900c5df3260fff.svg";
export { ForwardRef as ReactComponent };